import { InjectionToken } from '@angular/core';

export interface ApiConfiguration {
  burial_societies_uri: string;
  individuals_uri: string;
  keycloak_uri: string,
  individuals_bulk_payments: string;
  claims_uri: string;
  workflow_uri: string;
  education_uri: string;
  reports_uri: string;
  file_storage_uri: string;
}

export const API_CONFIGURATION_TOKEN = new InjectionToken<ApiConfiguration>(
  `Configure Api Endpoints`
);
